export class FetchBankRequest {
  constructor(public iban?: string, public swift?: string) {
  };
}
